import { useTranslation } from 'react-i18next';
import ShareButton from '@quicktools/shared-components/components/common/Widgets/ShareButton';
import Link from 'next/link';

import analytics from '../../../services/analytics';
import { quicktoolsLogoSrc } from '../../../constants';

import useStyles from './styles';

function AppLogo() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <a href="/">
        <img src={quicktoolsLogoSrc} alt="AI Writer Logo" className={classes.image} />
      </a>
      <Link href="/text/ai-writer/" passHref>
        <a>
          <span className={classes.title}>{t('editor.logo.text')}</span>
        </a>
      </Link>
      <ShareButton analytics={analytics} toolName={''} className={classes.share} />
    </div>
  );
}
export default AppLogo;
